module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Bold-Alphabetic.85bc804d.woff2";